import trackerService from './tracker.service';

type HlsTrackerService = 'inHouseSimulive' | 'liveHybridVideo';

/**
 * Factory that returns tracker helpers bound to a specific HLS service name.
 * Shared between simulive and liveHybrid — eliminates copy-pasted tracker calls.
 */
export function createHlsTrackers(service: HlsTrackerService) {
  return {
    /** Tracks a level switch and returns whether it was a downgrade. */
    trackLevelSwitched(previousLevel: number, newLevel: number): boolean {
      const isDowngrade = previousLevel !== -1 && newLevel < previousLevel;
      trackerService.track(service, 'levelSwitchCount');
      if (isDowngrade) {
        trackerService.track(service, 'levelSwitchDownCount');
      }
      return isDowngrade;
    },

    trackFragLoaded(loadTime: number): void {
      if (loadTime > 0) {
        trackerService.track(service, 'fragLoaded', { loadTime });
      }
    },

    trackFpsDrop(droppedFrames: number): void {
      trackerService.track(service, 'fpsDrop', { droppedFrames });
    },

    trackBufferStart(timestamp: number): void {
      trackerService.track(service, 'bufferStart', { timestamp });
    },

    trackBufferEnd(): void {
      trackerService.track(service, 'bufferEnd', { timestamp: Date.now() });
    },

    trackConnectionEstablished(): void {
      trackerService.track(service, 'connectionEstablished', { timestamp: Date.now() });
    },

    trackNonFatalError(): void {
      trackerService.track(service, 'nonFatalError');
    }
  };
}
